import React, { useCallback, useEffect, useState, createRef } from 'react';
import { useIntl } from 'react-intl';
import { api } from '../../../../../../api';
import { validateEmail, validateCpf } from "../../../../../../utils/validate";
import './styles.scss';
import { CheckCircle, X } from 'react-feather';

const EditUserModal = ({ setError, data, onClose }) => {

  const [name, setName] = useState("");
  const [id, setId] = useState("");
  const [email, setEmail] = useState("");
  const [cpf, setCpf] = useState({ value: "", raw: "" });
  const [cep, setCep] = useState("");
  const [logradouro, setLogradouro] = useState("");
  const [numero, setNumero] = useState("");
  const [complemento, setComplemento] = useState("");
  const [bairro, setBairro] = useState("");
  const [estados, setEstados] = useState("");
  const [estadoId, setEstadoId] = useState('');
  const [estadoSigla, setEstadoSigla] = useState('');
  const [municipios, setMunicipios] = useState("");
  const [municipioSelecionado, setMunicipioSelecionado] = useState("");
  const [phone_one, setPhone_one] = useState("");
  const [phone_two, setPhone_two] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [userAtivo, setUserAtivo] = useState("");
  const [userValidado, setUserValidado] = useState("");
  const [userCreated, setUserCreated] = useState("");

  const { formatMessage } = useIntl();
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const { formatMessage: f } = useIntl();

  let nameInput = createRef();

  const hasAllRequiredFields = () =>
    name.length !== 0 &&
    email.length !== 0 &&
    cpf.value.length !== 0;

  const generateRequiredFieldsMessage = () => {
    const errorFields = [];
    if (name.length === 0) errorFields.push("nome");
    if (email.length === 0) errorFields.push("e-mail");
    if (cpf.value.length === 0) errorFields.push("CPF");

    return (
      "Informe " +
      errorFields.reduce(
        (prev, field, index) =>
          prev + (index === errorFields.length - 1 ? " e " : ", ") + field
      )
    );
  };

  const getUserInfo = useCallback(() => {
    api.get(`/users/get_user_all?id=${data}`)
      .then(({data: response }) => {

        if(response){
          if(response.User){
            setEmail(response.User.username);
            setId(response.User.id);
            setUserCreated(response.User.created);
            setUserAtivo(response.User.ativo);
            setUserValidado(response.User.validado);
          }
          if(response.PessoaFisica){
            setName(response.PessoaFisica.nome);
            setCpf({value: response.PessoaFisica.cpf ? response.PessoaFisica.cpf : '',
                    raw: response.PessoaFisica.cpf ? response.PessoaFisica.cpf : '' });
            if(response.PessoaFisica.data_nascimento){
              const [dia, mes, ano] = response.PessoaFisica.data_nascimento.split(".");
              const data_nascimento_formatada = `${ano}-${mes}-${dia}`;
              setDataNascimento(data_nascimento_formatada);
            }
          }
          if(response.PessoaFisica?.endereco && response.PessoaFisica?.endereco[0]){
            setBairro(response.PessoaFisica.endereco[0].bairro);
            setCep(response.PessoaFisica.endereco[0].cep);
            setComplemento(response.PessoaFisica.endereco[0].complemento);
            setLogradouro(response.PessoaFisica.endereco[0].logradouro);
            setNumero(response.PessoaFisica.endereco[0].numero);
            setEstadoId(response.PessoaFisica.endereco[0].estado_id ? response.PessoaFisica.endereco[0].estado_id : '' );
            setMunicipioSelecionado(response.PessoaFisica.endereco[0].municipio_id ? response.PessoaFisica.endereco[0].municipio_id : '' );
          }
          if(response.PessoaFisica?.telefone && response.PessoaFisica.telefone[0]){
            setPhone_one(response.PessoaFisica.telefone[0].celular);
            setPhone_two(response.PessoaFisica.telefone[0].telefone);
          }
        }

        setLoading(false);
      })
      .catch(() => {
        setErrorMessage(formatMessage({ id: "erro-api" }));
        setLoading(false);
      });
  }, [data, formatMessage, setError]);

  const handleCpfChange = useCallback(
    unformattedCpf => {
      const raw = unformattedCpf.replace(/([^\d])/g, "");
      const value = raw.replace(
        /^(\d{3})(\d{3})(\d{3})(\d{2})(.*)/,
        "$1.$2.$3-$4"
      );
      setCpf({ value, raw });
    },
    [setCpf]
  );

  const formatPhone = (value) => {
    value = value.replace(/\D/g, '');

    if (value.length < 3) return value;

    if (value.length <= 10) {
      return value
        .replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3')
        .trim();
    } else {
      return value
        .replace(/^(\d{2})(\d{5})(\d{0,4}).*/, '($1) $2-$3')
        .trim();
    }
  };

  const handleChange = (setter) => (e) => {
    const onlyNums = e.target.value.replace(/\D/g, '');
    setter(onlyNums);
  };

  const handleBlur = (setter) => (e) => {
    setter(formatPhone(e.target.value));
  };

  const handleChangeCep = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setCep(value);
  };

  const handleBlurCep = () => {
    if (cep.length === 8) {
      fetch(`https://viacep.com.br/ws/${cep}/json/`)
        .then((response) => response.json())
        .then((data) => {
          if (!data.erro) {
            setLogradouro(data.logradouro);
            setBairro(data.bairro);
            setComplemento(data.complemento);
            setNumero(data.numero);
            setEstadoId(data.ibge.replace(/^(\d{2}).*/, '$1'));
            setMunicipioSelecionado(data.ibge);
          } else {
            setLogradouro('CEP não encontrado');
          }
        })
        .catch(() => {
          setLogradouro('Erro ao buscar CEP');
        });
    } else {
      setLogradouro(''); // Se cep não completo, limpa
    }
  };

  const handleUserUpdate = e => {
    e.preventDefault();

    if (!hasAllRequiredFields()) {
      setErrorMessage(generateRequiredFieldsMessage());
    } else if (!validateEmail(email)) {
      setErrorMessage(f({ id: "email-invalido" }));
    } else if (!validateCpf(cpf.raw)) {
      setErrorMessage(f({ id: "cpf-invalido" }));
    } else {
      setLoading(true);
      api
        .post("/users/update_user", {
          id: id,
          email: email,
          ativo: userAtivo ? userAtivo : false,
          validado: userValidado ? userValidado : false ,
          PessoaFisica: {
            name: name,
            cpf: cpf.value,
            dataNascimento: dataNascimento ? dataNascimento : null,
          },
          endereco: {
            cep: cep ? cep : null,
            logradouro: logradouro ? logradouro : null,
            numero: numero ? numero : null,
            complemento: complemento ? complemento : null,
            bairro: bairro ? bairro : null,
            estado: estadoId ? estadoId : null,
            municipio: municipioSelecionado ? municipioSelecionado : null,
          },
          telefone: {
            celular: phone_one ? phone_one : '',
            telefone: phone_two ? phone_two : ''
          },
        })
        .then(res => {
          alert('Cadastro Atualizado com sucesso!');
          onClose();
        })
        .catch(error => {
          setErrorMessage(error.response.data.message || f({ id: "erro-api" }));
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    nameInput.current && nameInput.current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    getUserInfo();
  }, [getUserInfo]);

  useEffect(() => {
    api.get(`/estados/get_all_state`)
      .then(({data: response }) => {       
        const result = response.map(e => e.Estado);
        setEstados(result);
      })
      .catch((error) => {
        console.error('Erro ao carregar estados:', error);
      });
  }, []);

  useEffect(() => {
    if (estadoId) {
      api.post(`/municipios/municipios_por_estado?estado_id=${estadoId}`)
      .then(({data: response }) => {
        const result = response.map(e => e.Municipio);
        setMunicipios(result);
        });
    } else {
      setMunicipios([]);
    }
  }, [estadoId]);

  return (
    <div className="modal edit-user-modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <div className="modal-card-title">
            {formatMessage({ id: "editar-cadastro" })}
          </div>
        </header>
        <section className="modal-card-body">
          {errorMessage ? (
            <div className="auth-error-message">{errorMessage}</div>
          ) : (
            <div className="auth-error-message-spacer"></div>
          )}

          <div className="input-container">
            <input
              ref={nameInput}
              type="text"
              name="name"
              placeholder={f({ id: "nome" })}
              value={name}
              required
              onChange={e => setName(e.target.value)}
            />
            <label htmlFor="name">{f({ id: "nome" })}</label>
          </div>

          <div className="input-container">
            <input
              type="email"
              name="email"
              placeholder="E-mail"
              value={email}
              required
              onChange={e => setEmail(e.target.value)}
            />
            <label htmlFor="email">E-mail</label>
          </div>

          <div className='input-container-dados'>
            <div className="input-container">
              <input
                name="cpf"
                placeholder="CPF"
                value={cpf.value}
                required
                onChange={e => handleCpfChange(e.target.value)}
              />
              <label htmlFor="cpf">CPF</label>
            </div>

            <div className="input-container">
              <input
                name="dataNascimento"
                type='date'
                placeholder="Data de Nascimento"
                value={dataNascimento}
                onChange={e => setDataNascimento(e.target.value)}
              />
              <label htmlFor="date">Data de Nascimento</label>
            </div>
          </div>

          <div className="input-phone">
            <div className="phone">
              <input
                name="Celular"
                placeholder="Celular"
                maxLength={15}
                value={phone_one}
                onChange={handleChange(setPhone_one)}
                onBlur={handleBlur(setPhone_one)}
              />
              <label htmlFor="celular">Celular</label>
            </div>

            <div className="phone">
              <input
                name="Telefone"
                placeholder="Telefone"
                maxLength={15}
                value={phone_two}
                onChange={handleChange(setPhone_two)}
                onBlur={handleBlur(setPhone_two)}
              />
              <label htmlFor="telefone">Telefone</label>
            </div>
          </div>

          <div className="input-container-endereco">
            <div className="input-endereco-cep">
              <div className="cep-lougradouro">
                <input
                  name="CEP"
                  placeholder="CEP"
                  value={cep}
                  maxLength={8}
                  onChange={handleChangeCep}
                  onBlur={handleBlurCep}
                />
                <label htmlFor="CEP">CEP</label>
              </div>
              <div className="cep-lougradouro">
                <input
                  name="logradouro"
                  placeholder="logradouro"
                  value={logradouro}
                  onChange={e => setLogradouro(e.target.value)}
                />
                <label htmlFor="logradouro">Logradouro</label>
              </div>
            </div>
            <div className="input-endereco-complemento">
              <div className="numero">
                <input
                  name="numero"
                  placeholder="Número"
                  value={numero}
                  onChange={e => setNumero(e.target.value)}
                />
                <label htmlFor="endereco">Número</label>
              </div>
              <div className="complemento">
                <input
                  name="complemento"
                  placeholder="Complemento"
                  value={complemento}
                  onChange={e => setComplemento(e.target.value)}
                />
                <label htmlFor="complemento">Complemento</label>
              </div>
              <div className="bairro">
                <input
                  name="bairro"
                  placeholder="bairro"
                  value={bairro}
                  onChange={e => setBairro(e.target.value)}
                />
                <label htmlFor="bairro">Bairro</label>
              </div>
            </div>
            <div className="input-endereco-estado">
              <div className="estado">
                <label htmlFor="estado">Estado</label>
                <select
                  id="estadoSelect"
                  value={estadoId}
                  onChange={(e) => {
                    const id = e.target.value;
                    setEstadoId(id);
                    const estado = estados.find((uf) => uf.id === parseInt(id));
                    setEstadoSigla(estado?.sigla || '');
                    setMunicipioSelecionado('');
                }}
                >
                  <option value="">Selecione o estado</option>
                  {estados && estados.map((estado) => (
                    <option key={estado.id} value={estado.id}>
                      {estado.nome_estado}
                    </option>
                  ))}
                </select>
              </div>
              <div className="municipio">
                <label htmlFor="municipio">Município</label>
                <select
                  id="municipioSelect"
                  value={municipioSelecionado}
                  onChange={(e) => setMunicipioSelecionado(e.target.value)}
                  disabled={!municipios.length}
                >
                  <option value="">Selecione o município</option>
                  {municipios && municipios.map((m) => (
                    <option key={m.id} value={m.id}>
                      {m.nome_municipio}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="input-container">
            <label >Data de Cadastro: {userCreated}</label>
          </div>

          <div className="input-user">
            <span>
              {f({ id: "cadastro-ativo" })}
            </span>
            <input
              type="checkbox"
              checked={userAtivo}
              onChange={e => setUserAtivo(e.target.checked)}
            />
          </div>
          <div className="input-user">
            <span>
              {f({ id: "cadastro-validado" })}
            </span>
            <input
              data-testid="accept-terms"
              type="checkbox"
              checked={userValidado}
              onChange={e => setUserValidado(e.target.checked)}
            />
          </div>

        </section>
        <footer className="modal-card-foot">
          <button
            className="button danger"
            onClick={onClose}
          >
            {formatMessage({ id: "cancelar" })}
          </button>

          <button
            className={`button primary ${loading ? "is-loading" : ""}`}
            disabled={!hasAllRequiredFields()}
            onClick={handleUserUpdate}
          >
            {formatMessage({ id: "atualizar-cadastro" })}
          </button>
        </footer>
      </div>
    </div>
  )
}

export default EditUserModal;